<!-- Добавить подсказку: double click on species name to expand data about species . Добавить кнопку ведущую на страницу "о чеклисте"-->
<template>
    <v-app theme="mainCustomLightTheme">
      <moss-header></moss-header>
      
      <div class="px-lg-3">
        <div class="text-h4 px-lg-1 px-1">
          Moss checklist of the Murmansk region
        </div>

<div class="text-h6 px-lg-1 px-1">

<!--link to about  and blah blah blah-->

  <base-checklist
    :dataset_uri="this.$store.state.mainurl+'/dataset/list?f='+230" 
    :tablestructur="this.$store.state.mainurl+'/dataset/list?f=100&f_id='+230"
    :spcffieldname="'ref_cfsspslfvsp_ckf2'"
    :spcffieldvalue="1"
    :mgroup="'ref_mgroup_qdry'"
    :mgroupvalue="1816"
    :areacoordvalue="'geotable:2171:4:geom'"
    :idtable="230"

  ></base-checklist>
</div>


</div>


          <base-footer></base-footer>
          </v-app>
          </template>
  
  <script>
  import { defineComponent } from 'vue';
  import MossHeader from './MossHeader.vue';
  import BaseChecklist from '@/components/BaseChecklist.vue';
  
  
  export default defineComponent({
    name: 'MossCheklistMurmansk',
  
    components: {
BaseChecklist,
MossHeader,
    },
    data: () => ({
      clicktooltip: 'Click to copy',
      }),
      methods: {
          clicktooltipMessage(){
            if (this.clicktooltip =='Click to copy') {
            this.clicktooltip = 'Copied';
            }
            else {
              this.clicktooltip = 'Click to copy';
            }
            setTimeout(() => {
          this.clicktooltip = 'Click to copy';
        }, 10000);
  
          },
  
      },
        
  });
  </script>
  